var onclickHandler = function (e) {
  var target = e.target.closest('[data-accordion]')
  if (target) {
    var exclude = e.target.closest('a,button')
    if (!exclude) {
      target.classList.toggle('active')
      target.nextElementSibling.classList.toggle('hide')
    }
  }
}

window.addEventListener('click', onclickHandler)

var onresetHandler = function() {
  Array.from(
    document.querySelectorAll('[data-accordion]')
  ).map(function(node) {
    node.classList.remove('active')
    node.nextElementSibling.classList.add('hide')
  })
}

window.addEventListener('reset', onresetHandler)
